import { KeyboardEvent } from 'react';

const handleKeyDown = (
  e: KeyboardEvent<HTMLElement>,
  fn: Function | undefined,
) => {
  if (['Enter', 'Space'].includes(e.code)) {
    fn?.();
  }
};

const formatBytes = (bytes: number, decimals = 1) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1000; // somehow on desktops we use 1000 instead of 1024. so i'm following that process.
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

const mapfileTypeToIcon = (fileType: string) => {
  switch (fileType) {
    case 'application/pdf':
      return 'icon-sys-document-pdf';

    case 'image/jpeg':
      return 'icon-sys-document-image';

    default:
      return 'icon-sys-document-document';
  }
};

const debounce = (fn: Function, ms = 300) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  // eslint-disable-next-line func-names
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

const isHorizontallyScrollable = (ele: HTMLElement) => {
  const hasScrollableContent = ele.scrollWidth > ele.clientWidth;
  const overflowXStyle = window.getComputedStyle(ele).overflowX;
  const isOverflowHidden = overflowXStyle.indexOf('hidden') !== -1;
  return hasScrollableContent && !isOverflowHidden;
};

const isVerticallyScrollable = (ele: HTMLElement) => {
  const hasScrollableContent = ele.scrollHeight > ele.clientHeight;
  const overflowYStyle = window.getComputedStyle(ele).overflowY;
  const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;
  return hasScrollableContent && !isOverflowHidden;
};

// format number currency to 1,223.34 format
const thousands = (amount: number) => amount.toLocaleString(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const getDateTime = (timestamp: number) => {
  const dateObj = new Date(timestamp * 1000);

  return {
    date: dateObj.toLocaleDateString('en-GB', {
      month: 'short',
      year: 'numeric',
      day: '2-digit',
    }),
    time: dateObj.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }),
  };
};

const openLink = (url: string) => {
  window.open(url, '_blank');
};

const downloadFile = (fileName: string, href: string) => {
  const link = document.createElement('a');
  link.href = href;
  link.download = `${fileName}`;
  link.click();
};

const getFileExtension = (filename: string) => {
  if (filename.indexOf('.') === -1) return ''
  return filename.split('.').slice(-1)[0].toUpperCase()
};

const limitTo24Characters = (label?: string) => {
  if (label && label.length > 24) {
    return label.substring(0, 24);
  }
  return label;
}

export {
  handleKeyDown,
  formatBytes,
  mapfileTypeToIcon,
  debounce,
  isHorizontallyScrollable,
  isVerticallyScrollable,
  thousands,
  getDateTime,
  openLink,
  downloadFile,
  getFileExtension,
  limitTo24Characters
};
